import { render, staticRenderFns } from "./Miscellaneous.vue?vue&type=template&id=0bd1b7a8"
import script from "./Miscellaneous.vue?vue&type=script&lang=js"
export * from "./Miscellaneous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports